import React, { useState } from 'react';
import { doQuickSetup } from '../../services/SettingsService';
import { processError } from '../../services/ServiceUtils';

function QuickSetupBanner({ onSuccess }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [done, setDone] = useState(false);

    async function handleSetup() {
        setLoading(true);
        setError('');
        try {
            await doQuickSetup();
            setDone(true);
            if (onSuccess) onSuccess();
        } catch (err) {
            const raw = processError(err);
            const msg = (raw && typeof raw === 'object') ? (raw.error || JSON.stringify(raw)) : (raw || '');
            if (msg.includes('Already exists') || msg.includes('already exists'))
                setError('Configuração inicial já existe. Use os Templates de Estratégia para criar mais.');
            else
                setError(msg || 'Erro ao criar configuração inicial.');
        } finally {
            setLoading(false);
        }
    }

    if (done) return null;

    return (
        <div className='card border-0 shadow mb-4'>
            <div className='card-body text-center py-5'>
                <div className='mb-3'>
                    <svg className='icon icon-lg text-primary' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' width='48' height='48'>
                        <path d='M10 3.5a1.5 1.5 0 013 0V4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3h.5a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.5a1.5 1.5 0 00-3 0v.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 00-1-1h-.5a1.5 1.5 0 010-3H4a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 001-1v-.5z' />
                    </svg>
                </div>
                <h5>Nenhuma configuração ainda</h5>
                <p className='text-muted small mb-3'>
                    Crie uma configuração inicial com um clique: monitor de candles (EMA 9/21) + automações de cruzamento de médias + estratégia para BTCUSDT.
                    <br />
                    <span className='text-warning'>Os registros serão criados inativos — revise e ative quando estiver pronto.</span>
                </p>
                {error && <div className='alert alert-warning py-2 small mb-3'>{error}</div>}
                <button
                    className='btn btn-primary me-2'
                    onClick={handleSetup}
                    disabled={loading}
                >
                    {loading ? 'Criando...' : '⚡ Criar configuração inicial (BTCUSDT)'}
                </button>
                <button
                    className='btn btn-outline-secondary'
                    data-bs-toggle='modal'
                    data-bs-target='#modalGuide'
                >
                    Ver guia completo
                </button>
            </div>
        </div>
    );
}

export default QuickSetupBanner;
